<div class="page-wrapper">
    <div class="page-content pt-0 pe-2 ps-2">
        <div class="container-fluid">
            <div class="default_class">
                <div class="content-wrapper p-0">

                    <div class="container-fluid">

                        <div class="row">
                            <div class="col-xl-12">
                                <div class="card rounded shadow-lg">
                                    <div class="card-header  headerbg" style="border-bottom:3px solid #d8eff8;">
                                        <h5 class="mb-0">My Tutors</h5>
                                    </div>
                                    <div class="card-body">

                                        <table id="patreggraph" datatable [dtOptions]="dtOptions"  [dtTrigger]="dtTrigger"
                                            class="table table-striped table-bordered mt-2 pt-2 table-sm small display"
                                            style="width:100%">
                                            <thead class="top" style="background-color: #624fd7; color:#ffffff;">
                                                <tr>
                                                    <th> Course Name</th>
                                                    <th> Start Date </th>
                                                    <th> End Date </th>
                                                    <th> Start Time </th>
                                                    <th> End Time </th>
                                                    <th> Tutor Name </th>
                                                    <!-- <th> Payment </th> -->

                                                </tr>
                                            </thead>
                                            <tbody>
                                                <tr *ngFor="let item of myCourseList">
                                                    <td>{{item.COURSE_NAME}}</td>
                                                    <td>{{item.COURSESHD_STARTDATE | date:'dd-MM-yyyy'}}</td>
                                                    <td>{{item.COURSESHD_ENDDATE | date:'dd-MM-yyyy'}}</td>
                                                    <td>{{item.COURSESHD_STARTTIME | date:'hh:mm a'}}</td>
                                                    <td>{{item.COURSESHD_ENDTIME | date:'hh:mm a'}}</td>
                                                    <td >
                                                        <a href="javascript: void(0)" style="cursor:pointer ;" (click)="tutorsProfile(item)">{{item.TNT_NAME}}</a>
                                                        </td>
                                                    <!-- <td>Paid</td> -->
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

<a class="d-none" target="_blank" id="openProfile"></a>